export default __webpack_public_path__ + "static/media/agro-svg-no-text.ed1abbb6.svg";